import styles from "./rethinking.module.css";
import AppBar from "../../components/appBar/appBar";
import ImgBuilder from "../../assets/ImgBuilder";
import AbortGame from "../../components/abortGame/abortGame";

import { saveRethinking } from "../../api/api";
import { useUserData } from '../../functions/updateUserData';
import { useLanguage } from '../../functions/setGetLanguage';
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Rethinking = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userData, setUserData } = useUserData();
  const { language } = useLanguage();

  const handleSubmit = async () => {
    try{

      const rethinking = {
        language: language.substring(1), // remove leading underscore
        trace_id: userData.headlineData.trace_id,

        answers: userData.headlineData.trace_steps.reduce((acc, item) => {
          acc[item.step_num] = item.answer;
          return acc;
        }, {})
      };
      await saveRethinking(userData.tokens.access_token, rethinking);
      navigate('/statistics')
    } catch (err) {
      console.error("Error: ",err);
    }
  };

  const handleSwitch = (idx) => {
    setUserData(prev => {
      const steps = prev.headlineData.trace_steps.map(step => {
        if (step.step_num === idx) {
          const newValue = step.answer === "reliable" ? "shady" : "reliable";
          return { ...step, answer: newValue };
        }
        return step;
      });
      return {
        ...prev,
        headlineData: {
          ...prev.headlineData,
          trace_steps: steps
        }
      };
    });
  };

  return (
    <div className={styles.wrapper}>
      <AppBar />
      <AbortGame />
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.topicsBg}/>
      <div className={styles.header}>
        <p className={styles.headerTitle}>{renderWithLineBreaksAndBold(t("news_page.rethinking"))}</p>
      </div>


      <div className={styles.content}>

        {userData.headlineData.trace_steps.map((item, idx) => (
          <div key={idx} className={styles.item}>
            <div className={styles.itemUpper}>
              <div className={styles.itemCircle}>{item.step_num}</div>
              <div className={styles.itemLine}></div>
              {/* <div className={styles.itemTitle}>{item.headline.title}</div> */}
            </div>
            <div className={styles.itemLower}>
              <div className={styles.itemHeadline}>
                {/* <img src={ImgBuilder.headline_blank} alt='headline' className={styles.headlinePicturePaper} /> */}
                <div className={styles.headlineTextPaperContainter}>
                  <p className={styles.headlineTextPaper}>{item.text}</p>
                </div>
              </div>

              <div onClick={() => handleSwitch(item.step_num)} className={`${styles.switcher} ${(item.answer === "reliable") ? styles.switcherActive : ''}`}>
                <div className={`${styles.switcherItem} ${(item.answer === "reliable") ? styles.switcherItemActive : ''}`}>{t("news_page.reliable_cut")}</div>
                <div className={`${styles.switcherItem} ${(item.answer === "reliable") ? '' : styles.switcherItemActive}`}>{t("news_page.shady_cut")}</div>
              </div>

            </div>
          </div>
        ))}
      </div>

      <div className={styles.buttonsContainer}>
        <button onClick={() => handleSubmit()}  className={styles.button}>{t("news_page.save")}</button>
      </div>

    </div>
  
  );
};

export default Rethinking;
